<script setup>
import { formatPercentage } from '@js/utils/formatter';

const {
    percentage1,
    percentage2 = undefined,
    percentage3 = undefined,
    suffix1 = undefined,
    withPlus = false,
    withDecimals = false,
    color = null,
} = defineProps({
    percentage1: {
        type: [Number, String],
        required: true,
    },
    percentage2: {
        type: [Number, String],
        required: false,
    },
    percentage3: {
        type: [Number, String],
        required: false,
    },
    suffix1: {
        type: String,
        required: false,
    },
    withPlus: {
        type: Boolean,
        required: false,
    },
    withDecimals: {
        type: Boolean,
        required: false,
    },
    color: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div
        class="flex h-full flex-col justify-center p-4"
        :class="{
            'bg-green-200 text-green-600': color === 'green',
            'bg-orange-200 text-orange-600': color === 'orange',
            'bg-red-200 text-red-600': color === 'red',
        }"
    >
        <div class="text-lg font-bold whitespace-nowrap">
            {{ formatPercentage(percentage1, withPlus, withDecimals) }}
            <span v-if="suffix1" class="text-base font-normal">
                {{ suffix1 }}
            </span>
        </div>

        <div
            v-if="percentage2 !== null && percentage2 !== undefined"
            class="whitespace-nowrap"
        >
            {{ formatPercentage(percentage2, withPlus, withDecimals) }}
        </div>

        <div
            v-if="percentage3 !== null && percentage3 !== undefined"
            class="whitespace-nowrap"
        >
            {{ formatPercentage(percentage3, withPlus, withDecimals) }}
        </div>
    </div>
</template>
